module.exports = __webpack_public_path__ + "img/Img20b_212096_BlFo-a.5f14acae.jpg";